import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ThomasAdvertiser } from 'models/interfaces';

const GET_ADVERTISER_QUERY = gql`
  query GetAdvertiser($tgrams_id: ID!) {
    thomasAdvertiser(tgrams_id: $tgrams_id) {
      name
      tgrams_id
    }
  }
`;

interface ThomasAdvertiserContainerRenderProps {
  thomasAdvertiser: ThomasAdvertiser;
}

interface ThomasAdvertiserContainerProps {
  tgrams_id: string;
  children: (props: ThomasAdvertiserContainerRenderProps) => any;
}

const ThomasAdvertiserContainer: React.FunctionComponent<ThomasAdvertiserContainerProps> = ({
  tgrams_id,
  children,
  ...props
}) => (
  <Query<ThomasAdvertiserContainerRenderProps> query={GET_ADVERTISER_QUERY} variables={{ tgrams_id }}>
    {({ data: { thomasAdvertiser } = { thomasAdvertiser: {} as ThomasAdvertiser}, loading }) => {
      if (loading) {
        return null;
      }
      return (
        children &&
        children({
          ...props,
          thomasAdvertiser
        })
      );
    }}
  </Query>
);

export default ThomasAdvertiserContainer;
